import { graphql } from '@/gql'

export const searchQuery = graphql(`
  query SearchQuery(
    $pagination: OffsetPaginationInput
    $search: String!
    $filters: SearchItemFilter = {}
    $ignoreMixContent: Boolean = false
    $prioritizedOrder: [String!]
    $isTeamOffer: Boolean = false
    $ignoreMixVendor: Boolean = false
    $ids: [String!]
  ) {
    search(
      search: $search
      pagination: $pagination
      filters: $filters
      ignoreMixContent: $ignoreMixContent
      prioritizedOrder: $prioritizedOrder
      isTeamOffer: $isTeamOffer
      ignoreMixVendor: $ignoreMixVendor
      ids: $ids
    ) {
      items {
        id
        text
        textEn
        category
        image {
          url
        }
        isBook
        itemId
        numberOfSessions
        order
        price
        priceAlterText
        usePlaceholderImage
        vendor {
          name
          smallImage {
            url
          }
        }
        priorityVendorLogo(resize: { max: { width: 200, height: 200 } }) {
          url
          width
          height
        }
      }
      totalItemsCount
    }
  }
`)

export const miniSearchQuery = graphql(`
  query MiniSearchQuery($search: String!) {
    miniSearch(search: $search) {
      blogs {
        id
        text
        textEn
        category
        image {
          url
        }
        isBook
        itemId
        numberOfSessions
        order
        price
        priceAlterText
        usePlaceholderImage
        vendor {
          name
          smallImage {
            url
          }
        }
      }
      products {
        id
        text
        textEn
        category
        image {
          url
        }
        isBook
        itemId
        numberOfSessions
        order
        price
        priceAlterText
        usePlaceholderImage
        vendor {
          name
          smallImage {
            url
          }
        }
      }
      experts {
        id
        text
        textEn
        category
        image {
          url
        }
        isBook
        itemId
        numberOfSessions
        order
        price
        priceAlterText
        usePlaceholderImage
        vendor {
          name
          smallImage {
            url
          }
        }
      }
    }
  }
`)

export const tagsQuery = graphql(`
  query TagQuery {
    tags {
      id
      slug
      name
      description
    }
  }
`)

export const searchHistoryQuery = graphql(`
  query SearchHistoryQuery($search: String!) {
    searchHistory(search: $search) {
      id
      search
      updatedAt
    }
  }
`)
